import { render, staticRenderFns } from "./LeftChart3.vue?vue&type=template&id=bb01a7c2&scoped=true&"
import script from "./LeftChart3.vue?vue&type=script&lang=js&"
export * from "./LeftChart3.vue?vue&type=script&lang=js&"
import style0 from "./LeftChart3.vue?vue&type=style&index=0&id=bb01a7c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb01a7c2",
  null
  
)

export default component.exports